/**
 * For a given path and dir name create a new path with trailing slash
 * @param dirPath
 * @param dirName
 */
export const generateNewDirPath = (
  dirPath: string | undefined,
  dirName: string
): string => {
  let path = '';
  
  if (dirPath && !dirPath.endsWith('/')) {
    path = `${dirPath}/`;
  } else if (dirPath) {
    path = dirPath;
  }
  
  return `${path}${dirName}/`;
};

/**
 * A valid directory name should not include any of the characters below
 */
export const validNameRegex = /^[^\\^/?*"><:|%]*$/;
